export default __webpack_public_path__ + "static/media/corretores.bd4b0121.png";